module.exports = __webpack_public_path__ + "static/media/no-image.4c5f8cbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/no-image.png
// module id = 52
// module chunks = 0